import Component from "grimoirejs/ref/Node/Component";
import IAttributeDeclaration from "grimoirejs/ref/Node/IAttributeDeclaration";
export default class RenderComponentBase extends Component{
    public static attributes: {[key: string]: IAttributeDeclaration} = {

    };
}



// WEBPACK FOOTER //
// ./src/Components/RenderComponentBase.ts